const Timeframe = {
    ALL: 'ALL',
    ONE_MONTH: '1M',
    ONE_YEAR: '1Y',
    SEVEN_DAYS: '1W',
    TODAY: '24H',
}

export default Timeframe
